<template>
  <div>
    <Top></Top>
    <div class="main w">
      <h2>無在庫販売</h2>
      <p>無在庫販売とは名の通り、商品の在庫を持たずに商品を販売する方法です。</p>
      <p>以前ではZC便提供しておりましたが、２０１９年４月１日より一回の発送に５ドルまでしか対応できないことに なりました。</p>
      <p>無在庫販売をされているお客様のご要望に応え弊社は独自の発送ルートを契約させて頂きました、そのため以前のZC便ルートは取</p>
      <p>り扱い中止になりましたので、ご注意ください。</p>
      <div class="content">
        <div class="fl txt1 txt">
          <h3>
            <span></span>新規無在庫ルート
          </h3>
          <p>
            ※
            <i></i> 日本での配送業者は佐川の配送。
          </p>
          <p>
            ※
            <i></i> 納期（目安）4日～ 弊社倉～発送先迄
          </p>
          <p>
            ※
            <i></i> 発送ご依頼主の名前や会社名（店舗名）を任意に記載できます。
          </p>
        </div>
        <div class="fl txt txt2">
          <div class="img">
            <img src="../../assets/img/show3.jpg" alt />
            <img src="../../assets/img/show_2.png" alt />
          </div>
          <h3>
            <span></span>新規無在庫ルート
          </h3>
          <p>
            ※
            <i></i> １箱積商品代金５０ドルまで
          </p>
          <p>
            ※
            <i></i> 梱包重量
          </p>
          <p>
            <i></i>
            <i></i>
            <i></i> 最大５KG、商品数量５個（着）
          </p>
          <p>
            ※
            <i></i>液体、磁性、電池を含む商品、ブランド品など商品発送禁止
          </p>
          <p>
            <i></i>
            <i></i>
            <i></i> 武器形状品、食品類、化粧品等も発送禁止対象になります
          </p>
        </div>
        <div class="fl txt">
          <h3>
            <span></span>手数料
          </h3>
          <p>
            ※
            <i></i> 通常代行手数料：商品代金 ５％
          </p>
          <p>
            ※
            <i></i> 発送手数料:１箱２点まで５元、それ以上の場合１点につき+５元になります。
          </p>
          <p>
            例
            <i></i> ４点の場合→発送手数料は15元
          </p>
          <p>
            ※
            <i></i> 北海道、沖縄に配送する場合は、70元／箱の配送料をプラス
          </p>
          <p>
            ※
            <i></i>返送手数料：1800円 受け取り拒否、住所不備や表札なし住所不明・初回配達
          </p>
          <p>
            <i></i>
            <i></i>
            <i></i> から５日経過し、返送された場合に発 生します。
          </p>
        </div>
      </div>
      <h4>
        <span></span>国際送料
        <a href="javascript:;">無在庫便</a>
      </h4>
      <ul>
        <li class="bg">重量</li>
        <li>~500g</li>
        <li>0.5kg~1kg</li>
        <li>1kg~1.5kg</li>
        <li>1.5kg~2kg</li>
        <li>2kg~2.5kg</li>
        <li>2.5kg~3kg</li>
        <li>3kg~3.5kg</li>
        <li>3.5kg~4kg</li>
        <li>4kg~4.5kg</li>
        <li>4.5kg~5kg</li>
      </ul>
      <ul class="yuan">
        <li class="bg" style="border-top:3px solid #fff">送料（元）</li>
        <li>54</li>
        <li>65</li>
        <li>76</li>
        <li>87</li>
        <li>98</li>
        <li>109</li>
        <li>120</li>
        <li>131</li>
        <li>142</li>
        <li>153</li>
      </ul>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {};
  },
  components: {
    Top,
    Foot
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  margin: 60px auto 100px;
  h2 {
    font-size: 36px;
    border-bottom: 1px solid #f3c622;
    color: #f3c622;
    margin-bottom: 20px;
  }
  p {
    font-size: 18px;
    color: #666;
    font-weight: 700;
    text-indent: 1.5em;
    line-height: 40px;
  }
  span {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #f3c622;
    margin-right: 10px;
  }
  .content {
    height: 585px;
    background-color: #f5f5f5;
    // overflow: hidden;
    .txt {
      padding: 30px 30px 0 15px;

      h3 {
        font-size: 24px;
        color: #333;
        font-weight: 700;
      }
      i {
        margin-right: 10px;
      }
    }
    .txt1 {
      height: 565px;
      border-right: 1px solid #f3c622;
    }
    .txt2 {
      border-bottom: 1px solid #f3c622;
      padding-right: 165px;
      position: relative;
      .img {
        position: absolute;
        right: 10px;
        top: 30px;
        img {
          width: 165px;
          height: 115px;
        }
      }
    }
  }
  h4 {
    margin-top: 50px;
    font-size: 24px;
    color: #333;
    font-weight: 700;
    margin-bottom: 20px;
    a {
      color: #f3c622;
      font-size: 16px;
      margin-left: 30px;
      text-decoration: underline;
    }
  }
  ul {
    display: flex;
    background-color: #f5f5f5;
    line-height: 75px;
    font-size: 16px;
    font-weight: 700;
    height: 75px;
    li {
      flex: 1;
      float: left;
      text-align: center;
      border-right: 1px solid #ccc;
    }
    .bg {
      background: #f3c622;
      color: #fff;
      border-right: 0;
    }
  }
  .yuan {
    li {
      border-top: 1px solid #ccc;
    }
  }
}
</style>